import React, { Component } from "react";
import {
    Row,
    Col,
    Table
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import moment from "moment";
import { getFullName } from "../../helpers/functions/employee";
import { getMonthNameFromNumber } from "../../helpers/functions/reports";

class BirthdayReport extends Component {

    render() {

        const { reportData, selectedMonth } = this.props;

        return (
            <Row>
              <div style={{
                marginTop: '60px'
              }}></div>
              <Col md={12}>
                <Card
                  title="Birthday Report"
                  category={getMonthNameFromNumber(selectedMonth)}
                  ctTableFullWidth
                  ctTableResponsive
                  content={
                    <Table striped hover>
                      <thead>
                        <tr>
                          <th>Birthday Date</th>
                          <th>Date Hired</th>
                          <th>Full Name</th>
                          <th>Remarks</th>
                          <th>Charging</th>
                        </tr>
                      </thead>
                      <tbody>
                      {reportData && reportData.length > 0 
                          ? reportData.map(employee => {
                            return (
                              <tr key={employee._id}>
                                <td>{moment(employee.birthdayDate).format("MM/DD/YYYY") || "N/A"}</td>
                                <td>{employee.dateHired ? moment(employee.dateHired).format("MM/DD/YYYY") : "N/A"}</td>
                                <td>{getFullName(employee) || 'N/A'}</td>
                                <td>???</td>
                                <td>???</td>
                              </tr>
                            )
                          })
                          : (
                            <tr>
                              <td colSpan='4'>There are no employees with birthday this month.</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </Table>
                  }
                />
              </Col>
            </Row>
        )
    }
}

export default BirthdayReport;
